import {
  createContext,
  ReactNode,
  useCallback,
  useMemo,
  useState,
} from "react";
import { useManageDrawer } from "src/hooks/useManageDrawer";
import UpdatePriceDrawer from "./components/UpdatePriceDrawer";
import { ProductPrice } from "src/api/types";

type ContextType = {
  updateActions: {
    handleOpen: () => void;
    handleClose: () => void;
  };
  price: ProductPrice | null;
  handleOpenUpdatePrice: (price: ProductPrice | null) => void;
};

export const PricesDrawerContext = createContext<ContextType>({
  updateActions: {
    handleClose: () => {},
    handleOpen: () => {},
  },
  price: null,
  handleOpenUpdatePrice: () => {},
});

interface Props {
  children: ReactNode;
}

const PricesDrawerProvider = ({ children }: Props) => {
  const [openUpdate, updateActions] = useManageDrawer();
  const [price, setPrice] = useState<ProductPrice | null>(null);

  const handleOpenUpdatePrice = useCallback(
    (price: ProductPrice | null) => {
      setPrice(price);
      updateActions.handleOpen();
    },
    [updateActions],
  );

  const value = useMemo(
    () => ({
      updateActions,
      price,
      handleOpenUpdatePrice,
    }),
    [handleOpenUpdatePrice, price, updateActions],
  );

  return (
    <PricesDrawerContext.Provider value={value}>
      {children}
      {price ? (
        <UpdatePriceDrawer
          open={openUpdate}
          onClose={updateActions.handleClose}
          price={price}
        />
      ) : null}
    </PricesDrawerContext.Provider>
  );
};

export default PricesDrawerProvider;
